export const ja = {
  service_name: "SECOM Sights",
  app_name: "個別キッティング",
  view_title: {
    cam_list: "キッティング一覧",
    read_qr: "QRコードの読込",
    regist_cam: "設置カメラ登録",
    interruption: "工事中断",
  },
  view_title_short: {
    regist_cam: "カメラ登録",
    setup_cam: "カメラセットアップ",
    setup_complete: "セットアップ完了",
    comp_procedure: "工事完了手順",
    comp: "工事完了",
  },
  label: {
    construct_id: "工事用ID",
    password: "パスワード",
    property_info: "設置先情報",
    camera_info: "設置カメラ情報",
    camera_list: "カメラ一覧",
    contract_code: "契約番号",
    model: "機種",
    model_number: "型番",
    serial: "シリアル",
    camera_id: "カメラ個別ID",
    camera_name: "名称",
    ai_setting: "AI設定",
    standard_img: "基準画像",
    finish_kitting: "個別キッティング完了",
    setting_incomp: "設定中",
    setting_comp: "設定済",
    unable_camera_list: "立ち上げ不可カメラ一覧",
    no_unable_camera_list: "立ち上げ不可のカメラはありません。",
    unable_camera_list_sub: "下記カメラの工事を中断します。",
    setting_comp_camera_list: "設定済みカメラ一覧",
    no_setting_comp_camera_list: "設定済みのカメラはありません。",
    setting_comp_camera_list_sub:
      "下記カメラは中断後もお客様にて利用可能です。",
    interruption: "工事を中断する",
  },
  btn: {
    login: "ログイン",
    logout: "ログアウト",
    cam_back: "　一覧へ戻る",
    close: "閉じる",
    cancel_scan: "読み取り中止",
    read_qrcode: "QRコード読込",
    regist_camera: "設置カメラ登録",
    setup_camera: "セットアップ",
    kitting_complete: "工事を完了する",
    cam_regist_page: "カメラ\n登録",
    cam_setup_page: "カメラ\nセットアップ",
    setup_remote: "リモート\nオペレーション\nセンター設定",
    call: "センターに連絡",
    report: "報告",
    interruption: "工事を中断する",
    comp: "工事を完了する",
  },
  status: {
    unapplied: "基準画像は申請中です…", // salesforce側では未申請
    unapproved: "基準画像は申請中です…", // salesforce側でも申請中
    rejected: "基準画像は承認却下されました",
    approved: "基準画像は承認されました",
    replaced: "基準画像は置き換え済みです",
    remote_center_rejected: "却下済",
    remote_center_dropped: "取下げ",
  },
  msg: {
    prepare_qrcode: "付属のQRコードを用意します",
    read_qrcode: "QRコードを読み込んでカメラを登録します",
    regist_camera: "物件とカメラを紐づけます",
    regist_camera_complete: "登録完了しました。",
    setup_camera:
      "続いてセットアップを行います。\nカメラの電源をONにしてください。",
    show_registration_info: "登録情報表示",
    cam_back: "一覧へ戻る",
    progress_setup_camera:
      "カメラセットアップ中です\n完了までは数分かかりますので\n少々お待ちください",
    finish_kitting:
      "基準画像の承認を確認しました。\nこれで個別キッティングは完了です。",
    setup_finish_kitting:
      "カメラセットアップが完了し、\nリモートオペレーションセンターへ\n確認を依頼しました。",
    running: "起動中",
    camera_start_err:
      "カメラを起動できませんでした。ブラウザにカメラの利用を許可してください。",
    read_camera_qrcode: "QRコードを読み込んでください",
    progress_camera: "カメラ情報を問い合わせています",
    open_qr_reader: "カメラが起動しますが、よろしいですか？",
    complete_construction:
      "個別キッティングを終了してログアウトします。\n実行すると再度ログインできなくなりますが、よろしいですか。",
    call_inquiry:
      "調整事項、トラブルが発生した場合は、\nセンターへ連絡してください。",
    remote_center_error: "確認事項があります",
    remote_center_comp: "セットアップ完了しました",
    center_comment: "センターのコメント：",
    report_title: "対応報告",
    interruption:
      "工事を中断する指示を受けた場合は、\n下記ボタンから工事を中断してください。",
    comp_procedure_1: "お客様にカメラの見え方を確認していただきます。",
    comp_procedure_2:
      "カメラの見え方に問題なければお客様から工事完了のサインを頂きます。",
    comp_procedure_3:
      "上記が完了したら、センターに内容を完了の連絡をしてください。",
    comp_procedure_4:
      "センターから工事完了を了解されたら下記ボタンから工事を完了します。",
    good_job: "お疲れ様でした。",
  },
  err: {
    timeout: "接続がタイムアウトしました。再度ログインしてください。",
    auth_error: "工事IDまたはパスワードが正しくありません。",
    camera_regist_error: "カメラ登録ができませんでした。",
    property_not_found: "該当の物件情報が見つかりません。",
    network: "ネットワークエラーが発生しました。",
    camera_not_found:
      "カメラ情報が見つかりません。再度QRコードを読み込んでください。",
    setup_camera_error: "カメラセットアップ中にエラーが発生しました",
    init_setup_camera_error: "カメラ初期設定中にエラーが発生しました",
    standard_img_approval:
      "リモートオペレーションセンター設定状況が取得できませんでした。",
    interruption_error: "工事中断にエラーが発生しました。",
    duplication_error: "すでに報告済みです。",
    report_error: "対応報告できませんでした。",
    check_camera_connection: "カメラの接続状態が確認ができませんでした。",
    camera_connection_status:
      "カメラがインターネットに接続されていません。\nLANケーブルが正しく接続されているか確認してください。",
    invalid_status: "カメラのステータスが不正です。",
  },
};
